// === SHOPIFY MARKETS CURRENCY PRICE UPDATER – USD OSNOVA ===
(function() {
  const priceMap = {
    'USD': { 70: '$70', 80: '$80', 100: '$100', 150: '$150' },
    'AED': { 70: 'AED 257', 80: 'AED 294', 100: 'AED 367', 150: 'AED 551' },
    'QAR': { 70: 'QAR 255', 80: 'QAR 291', 100: 'QAR 364', 150: 'QAR 546' },
    'SAR': { 70: 'SAR 263', 80: 'SAR 300', 100: 'SAR 375', 150: 'SAR 563' },
    'CAD': { 70: 'C$97', 80: 'C$110', 100: 'C$138', 150: 'C$207' },
    'GBP': { 70: '£52', 80: '£60', 100: '£75', 150: '£112' },
    'CHF': { 70: 'CHF 56', 80: 'CHF 64', 100: 'CHF 80', 150: 'CHF 119' },
    'SGD': { 70: 'S$90', 80: 'S$103', 100: 'S$129', 150: 'S$194' },
    'HKD': { 70: 'HK$545', 80: 'HK$623', 100: 'HK$778', 150: 'HK$1,167' },
    'JPY': { 70: '¥11,000', 80: '¥12,600', 100: '¥15,750', 150: '¥23,600' },
    'BND': { 70: 'B$90', 80: 'B$103', 100: 'B$129', 150: 'B$194' }
  };

  let isUpdating = false;

  function getCurrency() {
    if (window.Shopify?.currency?.active) return window.Shopify.currency.active;

    const input = document.querySelector('input[name="country_code"]');
    if (!input?.value) return 'USD';

    const map = {
      'AE': 'AED', 'QA': 'QAR', 'SA': 'SAR', 'CA': 'CAD',
      'GB': 'GBP', 'CH': 'CHF', 'SG': 'SGD', 'HK': 'HKD',
      'JP': 'JPY', 'BN': 'BND'
    };
    return map[input.value] || 'USD';
  }

  function replacePrices(text, prices) {
    return text
      .replace(/\$\s?150|150\s?\$/gi, prices[150])
      .replace(/\$\s?100|100\s?\$/gi, prices[100])
      .replace(/\$\s?80|80\s?\$/gi, prices[80])
      .replace(/\$\s?70|70\s?\$/gi, prices[70]);
  }

  function updatePrices() {
    if (isUpdating) return;

    const currency = getCurrency();

    if (currency === 'USD') return;

    isUpdating = true;

    const prices = priceMap[currency];

    document.querySelectorAll('.announcement-bar__static-list p, announcement-bar p').forEach(p => {
      const newText = replacePrices(p.textContent, prices);
      if (p.textContent !== newText) {
        p.textContent = newText;
      }
    });

    document.querySelectorAll('.product-info__block-item[data-block-type="offer"] .prose li').forEach(li => {
      const newHtml = replacePrices(li.innerHTML, prices);
      if (li.innerHTML !== newHtml) {
        li.innerHTML = newHtml;
      }
    });

    isUpdating = false;
  }

  function debounce(fn, delay) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  const debouncedUpdate = debounce(updatePrices, 100);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePrices);
  } else {
    updatePrices();
  }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-disclosure-option], .localization-selector')) {
      setTimeout(updatePrices, 200);
    }
  });

  document.addEventListener('currency.change', updatePrices);

  const observer = new MutationObserver(debouncedUpdate);
  observer.observe(document.body, { childList: true, subtree: true });

})();